import { render, staticRenderFns } from "./documents-show-files-modal.vue?vue&type=template&id=d9da9036&scoped=true&"
import script from "./documents-show-files-modal.vue?vue&type=script&lang=js&"
export * from "./documents-show-files-modal.vue?vue&type=script&lang=js&"
import style0 from "./documents-show-files-modal.vue?vue&type=style&index=0&id=d9da9036&lang=scss&scoped=true&"
import style1 from "./documents-show-files-modal.vue?vue&type=style&index=1&id=d9da9036&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9da9036",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9da9036')) {
      api.createRecord('d9da9036', component.options)
    } else {
      api.reload('d9da9036', component.options)
    }
    module.hot.accept("./documents-show-files-modal.vue?vue&type=template&id=d9da9036&scoped=true&", function () {
      api.rerender('d9da9036', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personal-employee/additions/modals/documents-show-files-modal.vue"
export default component.exports